/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const environment = {
	production: false,
	isMocked: false,
	baseUrl: "https://dev.ictcarboncalculator.com/",
	apiUrl: "https://gateway.dev.ictcarboncalculator.com/dashboard/api/v1",
	apiGatewayUrl: "https://gateway.dev.ictcarboncalculator.com/dashboard/api/v1/login",
	dashboardExportFileName: "dashboard_export",
	keycloakUrl: "https://dev.ictcarboncalculator.com/api/v1/login"
};
